import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "x-page-header__description"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'XPageHeader',
  props: {
  noMobileTabs: { type: Boolean },
  description: { type: String },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["x-page-header", { 'x-page-header--no-mobile-tabs': __props.noMobileTabs }])
  }, [
    (__props.description)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})